import { combineReducers } from "redux";
import { JobPackWrapper } from "../../../wrappers";
import {
    JobPackAssignessArrayListWidget,
    JobPackVehicleListWidget,
    JobPackEquipmentListWidget,
    JobPackGeneralFilesWidget,
    JobPackMethodStatementWidget,
    JobPackProfileRelatedReportsWidget,
    JobPackSelectReports,
    JobPackTrainingRulesWidget,
    JobPackToolboxTalkWidget,
} from "../../../widgets";
import {
    SET_PAGE_TYPE,
    GET_USER,
    GET_CONFIG,
    GET_AREAS,
    GET_DEPARTMENTS,
} from "./types";
import {
    JOB_PACK_GENERAL_FILES_TYPES,
    JOB_PACK_GENERAL_FILES_REDUCER,
} from "./JobPackV3";
const JobPackGeneralFilesWidget_types = JobPackGeneralFilesWidget.createTypes(
    JOB_PACK_GENERAL_FILES_TYPES
);
const JobPackGeneralFilesWidget_reducer = JobPackGeneralFilesWidget.createReducer(
    JobPackGeneralFilesWidget_types
);
const INITIAL_STATE = {
    pageType: false,
    config: false,
    profile: false,
    areas: false,
    departments: false,
};
const parentReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_PAGE_TYPE: {
            return { ...state, pageType: action.payload };
        }
        case GET_USER.REQUEST: {
            return { ...state, requesting: true, profile: false };
        }
        case GET_USER.SUCCESS: {
            return {
                ...state,
                requesting: false,
                profile: action.payload,
            };
        }
        case GET_AREAS.FAIL: {
            return { ...state, requesting: false, areas: false };
        }
        case GET_AREAS.REQUEST: {
            return { ...state, requesting: true, areas: false };
        }
        case GET_AREAS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                areas: action.payload,
            };
        }
        case GET_DEPARTMENTS.FAIL: {
            return { ...state, requesting: false, departments: false };
        }
        case GET_DEPARTMENTS.REQUEST: {
            return { ...state, requesting: true, departments: false };
        }
        case GET_DEPARTMENTS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                departments: action.payload,
            };
        }
        case GET_USER.FAIL: {
            return { ...state, requesting: false, profile: false };
        }
        case GET_CONFIG.REQUEST: {
            return { ...state, requesting: true, config: false };
        }
        case GET_CONFIG.SUCCESS: {
            return {
                ...state,
                requesting: false,
                config: action.payload,
            };
        }
        case GET_CONFIG.FAIL: {
            return { ...state, requesting: false, config: false };
        }
        default: {
            return { ...state };
        }
    }
};
export default combineReducers({
    [JOB_PACK_GENERAL_FILES_REDUCER]: JobPackGeneralFilesWidget_reducer,
    [JobPackVehicleListWidget.reducer_key]: JobPackVehicleListWidget.reducer,
    [JobPackEquipmentListWidget.reducer_key]:
        JobPackEquipmentListWidget.reducer,
    [JobPackToolboxTalkWidget.reducer_key]: JobPackToolboxTalkWidget.reducer,
    [JobPackWrapper.reducer_key]: JobPackWrapper.reducer,
    [JobPackAssignessArrayListWidget.reducer_key]:
        JobPackAssignessArrayListWidget.reducer,
    [JobPackMethodStatementWidget.reducer_key]:
        JobPackMethodStatementWidget.reducer,
    [JobPackTrainingRulesWidget.reducer_key]:
        JobPackTrainingRulesWidget.reducer,
    [JobPackProfileRelatedReportsWidget.reducer_key]:
        JobPackProfileRelatedReportsWidget.reducer,
    [JobPackSelectReports.reducer_key]: JobPackSelectReports.reducer,
    parentReducer,
});
